import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	retry: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	retry: {
		id: 'common.components.error-state.retry-action',
		defaultMessage: 'Try again',
		description: 'Text shown on a button that will retry a failed operation when clicked.',
	},
});
export default messages;
